import Sentry from 'modules/sentry';
import Config from 'modules/config';
// import GA from 'modules/ga';

const trackResponseTime = (
  responseTimeMs: number,
  { fullURL, fetchArgs }: { fullURL: string; fetchArgs: object },
): void => {
  // GA.timing({
  //   category: 'apiFetch',
  //   variable: 'call completed',
  //   value: responseTimeMs,
  //   label: fullURL,
  // });

  if (responseTimeMs > Config.ALARM_FETCH_RESPONSE_MAX_TIME_MS) {
    console.devLog.info('Server high response time', responseTimeMs);
    Sentry.addBreadcrumb({
      message: `High response time of ${responseTimeMs} ms`,
      category: 'apiFetch',
      data: {
        responseTimeMs,
        fullURL,
        fetchArgs,
      },
    });
    // Sentry.captureException(new Error('High response time'));
  }
};

export default trackResponseTime;
